import { type MasonryEngineActionHandler } from '@leagueplatform/masonry-engine';
import {
  MasonryDriverAction,
  MasonryDeeplinkAction,
} from '@leagueplatform/masonry-renderers';

export const masonryGoBackActionHandler: MasonryEngineActionHandler<
  MasonryDeeplinkAction,
  MasonryDriverAction
> = () => {
  window.history.back();
};
